import React, { useEffect } from "react";
import { Button, Box, Typography, Tooltip } from "@material-ui/core";
import {
  useRecoilValue,
  useRecoilState,
  useResetRecoilState,
} from "recoil";
import {
  isArchiveState,
  selectedSuccessStoryState,
  pdfLoaderState,
  previewSuccessStorystate,
} from "Recoil/SuccessStory/atom";
// import { SUCCESS_STORY_TYPE } from "../constants";
import { ChevronLeft } from "@material-ui/icons";
import DownloadIcon from "Assets/images/download-icon.svg";
import useStyles from "./styles";
import {
  REPORTS,
  SUCCESS_STORIES,
  ARCHIVE,
  PERFORMANCE_REVIEW,
} from "src/constants/routeConstants";
import { useHistory } from "react-router";
import LoadingWidget from "Components/widgets/LoadingWidget";
import { useSuccessStory } from "Hooks/successStory/useSuccessStory";
import { successStoryListingState } from "Recoil/DashboardReports/atom";
import { updateOrangeDotStatus } from "GraphQL/mutation/targetReview";
import { useMutation } from "@apollo/client";

const Header = () => {
  const classes = useStyles();
  const selectedSuccessStory = useRecoilValue(selectedSuccessStoryState);
  const resetState = useResetRecoilState(previewSuccessStorystate);
  const successStories = useRecoilValue(successStoryListingState);
  const [updateOrangeDotRatingStatus] = useMutation(updateOrangeDotStatus);



  // const [pdfLoader, setPdfLoader] = useState(false);
  const [pdfLoader, setPdfLoader] = useRecoilState(pdfLoaderState);
  // const [anchorEl, setAnchorEl] = useState(null);
  const isArchive = useRecoilValue(isArchiveState);
  const { downloadSuccessStory } = useSuccessStory();
  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  const history = useHistory();
  // const [downloadSuccessStory] = useLazyQuery(successStoryDownload, {
  //   fetchPolicy: FETCH_POLICY.networkOnly,
  //   onCompleted: (data) => {
  //     handleClose();
  //     const a = document.createElement("a");
  //     a.target = "_blank";
  //     a.href = get(data, "successStoryDownload.file", "");
  //     a.download = get(data, "successStoryDownload.fileName", "");
  //     a.click();
  //     setPdfLoader(false);
  //   },
  // });

  const downloadSelectedFile = () => {
    setPdfLoader(true);
    downloadSuccessStory({
      variables: {
        id: selectedSuccessStory?.id,
      },
    });
  };
  useEffect(() => {
    if (selectedSuccessStory) {
          handleSSOrangeDot(selectedSuccessStory);
    }
  }, [selectedSuccessStory]);


  const handleSSOrangeDot = (successStoryData) => {   
    if (successStoryData?.isNewHighlight || successStoryData?.isNew) {
      updateOrangeDotRatingStatus({
        variables: {
          input: {
            SSPRId: [successStoryData?.id],
            isNewHighlighted: false,
          },
        },
      })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  return (
    // <Fragment>
    //   <Grid container spacing={3}>
    //     <Grid
    //       container
    //       item
    //       xs={12}
    //       md={6}
    //       alignItems="center"
    //       className={classes.gridOrder}>
    //       {selectedReportType &&
    //         SUCCESS_STORY_TYPE.map((res, key) => {
    //           return (
    //             <Button
    //               key={key}
    //               data-testid="setReportType"
    //               onClick={() => setReportType(res)}
    //               className={
    //                 get(selectedReportType, "key") === res.key
    //                   ? classes.selectedBtnColor
    //                   : classes.btnBorder
    //               }>
    //               {res.value}
    //             </Button>
    //           );
    //         })}
    //     </Grid>
    //     <Grid container item xs={12} md={6} justify="flex-end">
    //       {get(reportDefaultDropdown, "id") && (
    //         <FormControl className={`${classes.selectGroup} mr15`}>
    //           <Select
    //             value={get(reportDefaultDropdown, "id")}
    //             id="grouped-select"
    //             label="Grouping"
    //             color="secondary"
    //             onChange={e => handlerSelectChange(e)}
    //             MenuProps={{
    //               anchorOrigin: {
    //                 vertical: "bottom",
    //                 horizontal: "left"
    //               },
    //               transformOrigin: {
    //                 vertical: "top",
    //                 horizontal: "left"
    //               },
    //               getContentAnchorEl: null
    //             }}>
    //             {getGroupOptions(dropdownOptions)}
    //           </Select>
    //         </FormControl>
    //       )}

    //       <Button
    //         variant="contained"
    //         color="primary"
    //         data-testid="setModal"
    //         onClick={() => {
    //           setModal(true);
    //         }}
    //         disabled={isEmptyData}>
    //         {t("uploadUser.download")}
    //       </Button>
    //     </Grid>
    //   </Grid>
    // </Fragment>
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      mt={2}
      className={classes.ssHeader}
    >
      <Tooltip title={selectedSuccessStory?.title}>
        <Typography variant="body1" className="font-semibold multi-wrap-2">
          {selectedSuccessStory?.title}
        </Typography>
      </Tooltip>
      <Box display="flex" alignItems="center" className={classes.actionBtns}>
        <Button
          data-testid="backToList"
          color="primary"
          onClick={() => {
            const isSS =
              (history?.location?.pathname).includes(SUCCESS_STORIES);
            // const isArchive = history?.location?.state?.formArchive;
            history?.push(
              `${REPORTS}${isSS ? SUCCESS_STORIES : PERFORMANCE_REVIEW}${
                isArchive ? ARCHIVE : ""
              }`
            );
            resetState();
          }}
        >
          <ChevronLeft fontSize="small" />
          Back to list
        </Button>
        <Button
          color="primary"
          className="ml10"
          onClick={() => {
            downloadSelectedFile();
          }}
          data-testid="downloadSelectedFile"
        >
          {pdfLoader ? (
            <LoadingWidget color="gray" />
          ) : (
            <>
              <img
                src={DownloadIcon}
                alt="download"
                width="20px"
                className="mr5"
                
              />
              Download
            </>
          )}
        </Button>
      </Box>
    </Box>
  );
};

export default Header;
